export default {
  ORDER_SUCCESS: 'ORDER_SUCCESS',
  ORDER_FAILED: 'ORDER_FAILED',
  ORDER_CANCELED: 'ORDER_CANCELED',
  ADD_CARD_SUCCESS: 'ADD_CARD_SUCCESS',
  ADD_CARD_FAILED: 'ADD_CARD_FAILED',
}
